import * as React from 'react';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import { Alert, Button, FormControl, IconButton, InputLabel, List, ListItemButton, ListItemIcon, ListItemText, MenuItem, Popover, Select, Snackbar, Stack, Tooltip, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FormatIndentIncrease, FormatLineSpacing, RadioButtonChecked } from '@mui/icons-material';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import CheckIcon from '@mui/icons-material/Check';

const IB = styled(IconButton)(({ theme }) => ({
    borderRadius: 0,
}));

const tipoInput = [
    1,
    1.15,
    1.5,
    2,
    2.5,
    3
]

export default function TextAlignmentPopover(props) {
    const { selectItem } = props;
    const [alinhamento, setAlinhamento] = React.useState('');
    const [distancia, setDistancia] = React.useState(1.5);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [anchorElLineHeight, setAnchorElLineHeight] = React.useState(null);
    const [msg, setMsg] = React.useState('');

    const [openSnack, setOpenSnack] = React.useState(false);

  const handleCloseSnack = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnack(false);
  };


    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const openLineHeight = Boolean(anchorElLineHeight);
    const idLineHeight = openLineHeight ? 'simple-popover' : undefined;

    React.useEffect(() => {
        setAlinhamento(selectItem?.style?.textAlign);
        setDistancia(selectItem?.style?.lineHeight)
    }, [selectItem]);

    const handleAlingTxt = (event) => {
        if( checkRange() ){
            setAnchorEl(event.currentTarget);
        }else{
            setOpenSnack(true);
            setMsg("Escolha um texto para alinhamento!.")
        }
    };

    const handleLineHeightTxt = (event) => {
        setAnchorElLineHeight(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleCloseLineHeight = () => {
        setAnchorElLineHeight(null);
    };
   
    function rangeRecursivo(comp){
        console.log( comp )
        if (comp.id === 'very2Editor') {
            return true;
        } else {
            if (comp.tagName === 'BODY') return false;
            return rangeRecursivo(comp.parentNode);
        }
        return false;
    }
    function checkRange(){
        const s = window.getSelection();
        if (s.rangeCount === 0) {
            return false;
        }
        const range = s.getRangeAt(0);
        const el = range.startContainer.parentNode;
        // console.log(e, e.tagName)
        // let el = range.commonAncestorContainer.parentNode;
        
        return rangeRecursivo(el);
    }
    
    const handleChangeAlinhamento = (alinha) => {
        // console.log( alinha, selectItem);

        const s = window.getSelection();
        if (s.rangeCount === 0) {
            alert("Nada selecionado!");
            return;
        }
        console.log(s);
        console.log(s.rangeCount);
        const range = s.getRangeAt(0);//s.baseNode;
        // let el = range.startContainer;//.cloneContents(); //extractContents();            
        // let el = range.commonAncestorContainer;//.parentNode;
        let el = range.startContainer.parentNode;
        // let el = range.commonAncestorContainer.parentNode;

        console.log( el, el.parentNode )
// return;
        // let el = selectItem;
        const id = el.id;
        if( id === 'very2Editor'){
            const html = el.innerHTML;
            el.innerHTML = '';
            const div = document.createElement("div");
            div.innerHTML = html;
            el.appendChild(div);
            el = div;            
        }

        if (el) {
            el.style.textAlign = alinha;
        } else {
            console.warn('Nenhum elemento selecionado para alinhar');
        }
        handleClose();

    };

    const handleListItemClick = (event, num) => {
        if (selectItem) {
            // Aplica o line-height no elemento
            selectItem.style.lineHeight = num;
            setDistancia(num);
        } else {
            console.warn('Nenhum elemento selecionado para alterar espaçamento');
        }

        handleCloseLineHeight();

    };

    return (
        <React.Fragment>
            <Tooltip title="Alinhamento de texto">
                <IB
                    // color="primary" 
                    onClick={handleAlingTxt}
                    size="small"
                // color={alinhamento ? 'primary' : 'secundary'}
                >
                    <FormatIndentIncrease />
                </IB>
            </Tooltip>
            <Tooltip title="Alinhamento de linha">
                <IB
                    // color="primary" 
                    onClick={handleLineHeightTxt}
                    size="small"
                >
                    <FormatLineSpacing />
                </IB>
            </Tooltip>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <Stack direction="row">
                    <Tooltip title="Alinhado à esquerda">
                        <IB
                            onClick={e => handleChangeAlinhamento('left')}
                            color={alinhamento == 'left' ? 'primary' : 'secundary'}
                        >
                            <FormatAlignLeftIcon />
                        </IB>
                    </Tooltip>
                    <Tooltip title="Alinhado à direita">
                        <IB
                            onClick={e => handleChangeAlinhamento('right')}
                            color={alinhamento == 'right' ? 'primary' : 'secundary'}
                        >
                            <FormatAlignRightIcon />
                        </IB>
                    </Tooltip>
                    <Tooltip title="Centralizado">
                        <IB
                            onClick={e => handleChangeAlinhamento('center')}
                            color={alinhamento == 'center' ? 'primary' : 'secundary'}
                        >
                            <FormatAlignCenterIcon />
                        </IB>
                    </Tooltip>
                    <Tooltip title="Justificado">
                        <IB
                            onClick={e => handleChangeAlinhamento('justify')}
                            color={alinhamento == 'justify' ? 'primary' : 'secundary'}
                        >
                            <FormatAlignJustifyIcon />
                        </IB>
                    </Tooltip>
                </Stack>
            </Popover>
            <Popover
                id={idLineHeight}
                open={openLineHeight}
                anchorEl={anchorElLineHeight}
                onClose={handleCloseLineHeight}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <Stack direction="row">
                    <List component="nav" aria-label="secondary mailbox folder">
                        {tipoInput.map((num, index) => (
                            <ListItemButton key={`${num}_item_${index}`}
                                selected={distancia === num}
                                onClick={(event) => handleListItemClick(event, num)}
                            >
                                <ListItemIcon>
                                    {distancia == num && <CheckIcon />}
                                </ListItemIcon>
                                <ListItemText primary={num} />
                            </ListItemButton>
                        ))}
                    </List>
                </Stack>
            </Popover>
<Snackbar open={openSnack} autoHideDuration={6000} onClose={handleCloseSnack}>
  <Alert
    onClose={handleCloseSnack}
    severity="success"
    variant="filled"
    sx={{ width: '100%' }}
  >
    {msg}
  </Alert>
</Snackbar>
        </React.Fragment>
    )
}